// Dependencies
import React, { ChangeEvent, useCallback, useEffect, useState } from "react";
import { When } from "react-if";
import { useNavigate } from "react-router-dom";
import { getToken, httpsUrlValidator, removeScheme } from "../utils";
import MonitorlyLogo from "./../images/monitorly-logo.png";

export default function PreHomepage() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Expire
    if (getToken()) {
      navigate("/dashboard/home");
    }
    setIsLoading(false);
  }, []);

  return isLoading ? null : <Homepage />;
}

function Homepage() {
  const [urlRaw, setUrl] = useState("");
  const [touched, setTouched] = useState(false);
  const [error, setError] = useState("");

  const [finalUrl, setFinalUrl] = useState("");
  const [step, setStep] = useState(0);

  const navigate = useNavigate();

  useEffect(() => {}, [urlRaw]);

  const onChangeInput = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setUrl(e.target.value);
    setError("");
    setTouched(true);
    setFinalUrl("");
    setStep(0);
  }, []);

  const onClickContinue = useCallback(() => {
    if (!urlRaw) {
      setError("Please enter a valid domain");
      return;
    }

    if (!httpsUrlValidator(urlRaw)) {
      setError("Invalid URL format. Please check and try again.");
      return;
    }

    navigate("/auth/login", {
      state: {
        url: removeScheme(urlRaw),
      },
    });
    // setFinalUrl(urlRaw);

    // setStep(1);
    // setTimeout(()=>{
    //   setStep(2);
    // },3000)
  }, [urlRaw]);

  return (
    <div className="h-screen flex flex-col items-center bg-primary">
      {/* <div className="bg-primary" style={{ flex: 2 }}></div> */}
      <div className="mt-36 mb-8 flex justify-center items-center">
          <img src={MonitorlyLogo} className="w-[70%]"/>
        </div>
      <div className="p-10 bg-white rounded-xl shadow-xl w-[495px]">
        
          <h1 className="text-2xl mb-5 text-center">Let's monitor your SSL</h1>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              onClickContinue();
            }}
          >
            <div className="mt-4">
              <p>Enter your domain</p>
              <input
                className="input-field-primary w-full my-2"
                placeholder="yourdomain.com"
                onChange={onChangeInput}
              ></input>
              <When condition={error}>
                <div>
                  <h3 className="text-red-500 text-base font-bold">{error}</h3>
                </div>
              </When>
            </div>

            <div className="mt-4">
              <button className="btn-accent mt-1.5 w-full">
                Next
              </button>
            </div>
          </form>
        </div>
    </div>
  );
}
